import { createElement as e, useEffect, useState } from 'react';
import { getPosts } from '../data/store';

const th = { padding: 8, textAlign: 'left', color: '#F5C518' };
const td = { padding: 8 , color: '#ddd'};

export default function Dispositivos() {
    const [devices, setDevices] = useState([]);
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [savingId, setSavingId] = useState(null);

  async function cargar() {
        setError('');
        try {
                const results = await Promise.all([
                          fetch('/api/devices').then((r) => r.json()),
                          getPosts(),
                        ]);
                const devResp = results[0];
                const pts = results[1];
                setDevices((devResp && devResp.devices) || []);
                setPosts(pts || []);
        } catch (err) {
                setError('No se pudo cargar la lista de dispositivos.');
        } finally {
                setLoading(false);
        }
  }

  useEffect(() => {
        cargar();
  }, []);

  async function actualizar(id, patch) {
        setSavingId(id);
        try {
                const body = Object.assign({ id: id }, patch);
                const resp = await fetch('/api/devices', {
                          method: 'PATCH',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify(body),
                });
                const json = await resp.json();
                if (json && json.device) {
                          setDevices(function (prev) {
                                      return prev.map(function (d) {
                                                    return d.id === id ? json.device : d;
                                      });
                          });
                }
        } catch (err) {
                setError('No se pudo actualizar el dispositivo.');
        } finally {
                setSavingId(null);
        }
  }

        async function eliminar(id) {
                    setSavingId(id);
                    try {
                                    const resp = await fetch('/api/devices?id=' + id, { method: 'DELETE' });
                                    const json = await resp.json();
                                    if (json && json.ok) {
                                                        setDevices(function (prev) { return prev.filter(function (d) { return d.id !== id; }); });
                                    } else {
                                                        setError('No se pudo eliminar el dispositivo.');
                                    }
                    } catch (err) {
                                    setError('No se pudo eliminar el dispositivo.');
                    } finally {
                                    setSavingId(null);
                    }
        }

  function nombrePuesto(postId) {
        const p = posts.find(function (x) { return String(x.id) === String(postId); });
        return p ? p.name : '';
  }

  const opcionesPuesto = [e('option', { key: '', value: '' }, 'Sin puesto asignado')].concat(
        posts.map(function (p) {
                return e('option', { key: p.id, value: p.id }, p.name);
        })
      );

  const sinConfigurar = function (d) {
                  const ids = Array.isArray(d.puesto_ids) ? d.puesto_ids : (d.puesto_id != null ? [d.puesto_id] : []);
                  return d.habilitado !== true || ids.length === 0;
  };
            const devicesOrdenados = devices.slice().sort(function (a, b) {
                            return (sinConfigurar(a) === sinConfigurar(b)) ? 0 : (sinConfigurar(a) ? -1 : 1);
            });
            const filas = devicesOrdenados.map(function (d) {
        const activo = d.habilitado === true;
        const bloqueado = d.bloqueado_a_puesto !== false;
        return e('tr', { key: d.id, style: { borderBottom: '1px solid #333', opacity: savingId === d.id ? 0.5 : 1 } },
                       e('td', { style: td },
                                                     e('div', null,
                                                                                       sinConfigurar(d) ? e('div', { style: { color: '#ff5555', fontSize: 11, marginBottom: 4, fontWeight: 'bold' } }, '⚠ Sin configurar') : null,
                                                                                       e('input', {
                                                                                                                               type: 'text',
                                                                                                                               defaultValue: d.nombre || '',
                                                                                                                               placeholder: 'Nombre del dispositivo',
                                                                                                                               onBlur: function (ev) {
                                                                                                                                                                           const val = ev.target.value;
                                                                                                                                                                           if (val !== (d.nombre || '')) actualizar(d.id, { nombre: val });
                                                                                                                                   },
                                                                                                                               style: { padding: 6, border: '1px solid #333', borderRadius: 6, width: 160, background: '#111', color: '#fff' },
                                                                                           })
                                                                                   )
                                                 ),
                       e('td', { style: td }, e('code', { style: { fontSize: 12 } }, String(d.device_uid || '').slice(0, 12))),
e('td', { style: td },
                      e('div', { style: { display:'flex', flexWrap:'wrap', gap:8, maxWidth:260 } },
                                                posts.map(function (p) {
                                                                                const ids = Array.isArray(d.puesto_ids) ? d.puesto_ids.map(String) : (d.puesto_id != null ? [String(d.puesto_id)] : []);
                                                                                const checked = ids.indexOf(String(p.id)) !== -1;
                                                                                return e('label', { key: p.id, style: { display:'flex', alignItems:'center', gap:4, cursor:'pointer', fontSize:11 } },
                                                                                                                         e('input', {
                                                                                                                                                                 type: 'checkbox',
                                                                                                                                                                 checked: checked,
                                                                                                                                                                 onChange: function (ev) {
                                                                                                                                                                                                             const current = Array.isArray(d.puesto_ids) ? d.puesto_ids.map(String) : (d.puesto_id != null ? [String(d.puesto_id)] : []);
                                                                                                                                                                                                             const next = ev.target.checked ? current.concat([String(p.id)]) : current.filter(function (x) { return x !== String(p.id); });
                                                                                                                                                                                                             actualizar(d.id, { puestoIds: next.map(Number) });
                                                                                                                                                                                                         }
                                                                                                                             }),
                                                                                                                         p.name
                                                                                                                     );
                                                })
                                            )
                  ),
                       e('td', { style: td },
                                 e('label', { style: { display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' } },
                                             e('input', {
                                                           type: 'checkbox',
                                                           checked: bloqueado,
                                                           onChange: function (ev) { actualizar(d.id, { bloqueadoAPuesto: ev.target.checked }); },
                                             }),
                                             'Bloqueado a puesto'
                                           )
                               ),
                       e('td', { style: td },
                                 e('label', { style: { display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' } },
                                             e('input', {
                                                           type: 'checkbox',
                                                           checked: activo,
                                                           onChange: function (ev) { actualizar(d.id, { habilitado: ev.target.checked }); },
                                             }),
                                             activo ? e('span', { style: { color: '#16a34a', fontWeight: 600 } }, 'Habilitado')
                                                    : e('span', { style: { color: '#dc2626', fontWeight: 600 } }, 'Deshabilitado')
                                           )
                               ),
                       e('td', { style: td }, d.ultima_actividad ? new Date(d.ultima_actividad).toLocaleString() : '-'),
                                 e('td', { style: td },
                                                       e('button', {
                                                                                   type: 'button',
                                                                                   onClick: function () {
                                                                                                                   if (window.confirm('Eliminar este dispositivo? Esta accion no se puede deshacer.')) { eliminar(d.id); }
                                                                                       },
                                                                                   style: { background:'rgba(220,38,38,0.15)', color:'#f87171', border:'1px solid rgba(220,38,38,0.3)', borderRadius:6, padding:'6px 12px', cursor:'pointer', fontSize:12 }
                                                           }, 'Eliminar')
                                                   )
                     );
  });

  if (devices.length === 0 && !loading) {
        filas.push(
                e('tr', { key: 'empty' },
                          e('td', { colSpan: 7, style: { padding: 16, textAlign: 'center', color: '#64748b' } },
                                      'Aun no hay dispositivos registrados. Cuando un empleado abra el Portal de Asistencia desde su telefono, aparecera aqui para que lo habilites.'
                                    )
                        )
              );
  }

  const headerRow = e('tr', { style: { textAlign: 'left', borderBottom: '2px solid rgba(255,255,255,0.08)' } },
                          e('th', { style: th }, 'Nombre'),
                          e('th', { style: th }, 'Device UID'),
                          e('th', { style: th }, 'Puesto asignado'),
                          e('th', { style: th }, 'Bloqueo'),
                          e('th', { style: th }, 'Estado'),
                          e('th', { style: th }, 'Ultima actividad'),
                                      e('th', { style: th }, 'Eliminar')
                        );

  return e('div', { style: { padding: 24, background: '#0d0d0d', color: '#fff', minHeight: '100vh' } },
               e('h1', { style: { fontSize: 24, fontWeight: 700, marginBottom: 8 } }, 'Dispositivos'),
               e('p', { style: { color: '#64748b', marginBottom: 16, maxWidth: 640 } },
                       'Cada telefono que se use para marcar Entrada/Salida debe ser habilitado aqui por un administrador. Puedes asignarlo a un puesto especifico y bloquearlo para que solo pueda marcar ponches en ese puesto.'
                     ),
               error ? e('div', { style: { color: '#dc2626', marginBottom: 12 } }, error) : null,
               loading ? e('div', { style: { color: '#64748b' } }, 'Cargando...') : e('div', { style: { overflowX: 'auto' } },
                                                                                            e('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: 14 } },
                                                                                                      e('thead', null, headerRow),
                                                                                                      e('tbody', null, filas)
                                                                                                    )
                                                                                          )
             );
}
